import * as React from 'react'
import { SVGProps } from 'react'
const SvgAddToCart2 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 22 22" {...props}>
    <path
      d="M8.25 8.25V5.5a2.75 2.75 0 0 1 5.5 0v2.75M11.5 18.333H4.583L5.5 6.417h11l.215 2.791.108 1.396.053.698.014.175"
      fill="none"
    />
    <path d="M17 14v6M20 17h-6" />
  </svg>
)
export default SvgAddToCart2
